import { TaskType } from 'shared/types/task-base';

import { TrackingTaskType } from './models/tracking-task-type';

export const taskTypeToTrackingTaskType: Record<TaskType, TrackingTaskType> = {
  [TaskType.Task]: TrackingTaskType.Todo,
  [TaskType.Habit]: TrackingTaskType.Habit,
  [TaskType.Repeating]: TrackingTaskType.Repeating,
};
